<!-- PatientFlagBadge.vue -->
<script setup lang="ts">
    import { colorFlagList, IPatientFlagBasicSettingsBase, GetColorClass } from '../../../lib/Models/Setup/PatientFlagSetupModel';
    import XSpan from '../../HtmlWrapper/XSpan.vue';
    import PatientFlagIcon from './PatientFlagIcon.vue';

    const props = defineProps<{
        flag?: IPatientFlagBasicSettingsBase,
        adjustForPadding?: boolean    // Use when the badge needs to be adjusted due to padding.  
    }>();

    function patientFlagClass(patientFlag: IPatientFlagBasicSettingsBase): string[] {
        return ["flag-item", 
                props.adjustForPadding ? "flag-item-adjust-for-padding" : "",
                GetColorClass(patientFlag.colorId)];
    }
</script>

<style>
    @import url('../../../../css/patientFlag.css');

    .flag-item {
        padding: 4px;
        margin-left: 2px;
        margin-right: 2px;
        border-radius: 3px;
        margin-bottom: 100px;
        white-space: nowrap;
      }    

    .flag-item-adjust-for-padding
    {
        position: relative;
        top: 4px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

</style>

<template>
    <XSpan v-if="flag" :class="patientFlagClass(flag)">
        <template v-if="flag.flagStyleIcon">
            <PatientFlagIcon :icon="flag.iconId" />
        </template>
        <template v-if="!flag.flagStyleIcon">
            {{ flag.shortDescription }}
        </template>                    
    </XSpan>
</template>